module.exports = __webpack_public_path__ + "img/bus-tiao-bg.afe5ff0d.png";